import { Quotation } from 'data-layer-cr/dist/models';

export default function getPackageDescription(
  currentQuotation: Quotation,
  deductibleOption: number,
): string {
  const selectedDeductibleOption = currentQuotation.units.find(
    (unit) => unit.deductibleOption === deductibleOption,
  )?.package.description;

  return selectedDeductibleOption === undefined ? '' : selectedDeductibleOption;
}
